// ** MUI Imports
import {
  Avatar,
  AvatarGroup,
  Box,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemAvatar,
  ListItemSecondaryAction,
  InputAdornment,
  Grid,
  Checkbox,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import CustomTextField from "../../../components/mui/text-field";

import Icon from "../../../components/icon";

import { useAssignToLogic } from "../logic/AssignToLogic";


const AssignToComponent = ({ 
  requestID, 
  serviceRequest, 
  rules, 
  setLoading,
  handleServiceRequestChange,
  navigate 
}) => {
  const { AssignToProps } = useAssignToLogic({
    serviceRequest, 
    setLoading, 
    requestID,  
    navigate, 
    handleServiceRequestChange, 
    });
  const {
    filteredEmployees,
    assignedUserIds,
    setSearchQuery,
    setChecked, 
    handleEmployeeCheck,
    setAssignedUserIds     
  } = AssignToProps;

  const handleClear = async () => {
    handleServiceRequestChange('assignedToUsers', []);
    setAssignedUserIds([]);
  };

  return (
    <>
      <Grid item xs={12} lg={6.1}>
      <Box
        sx={{ display: "flex", alignItems: "center", height: "100%" }}
      >
      <AvatarGroup
        className="pull-up"
        max={4}
        sx={{
          "& .MuiAvatar-root": { width: 25, height: 25 },
          "& .MuiAvatarGroup-avatar": { width: 25, height: 25 },
        }}
      >
        {filteredEmployees && filteredEmployees
          .filter(employee => assignedUserIds.includes(employee.employeeID))
          .map((employee, index) => {
            const employeeFullName = `${employee.firstName} ${employee.lastName}`;
            return (
              <Tooltip key={employee.employeeID} title={employeeFullName}>
                <Avatar
                  src={employee.avatarUrl || `/images/avatars/${index + 1}.png`}
                  alt={employeeFullName}
                  sx={{ width: 25, height: 25 }}
                />
              </Tooltip>
            );
          })}
      </AvatarGroup>


      </Box>
      </Grid>
      <Grid item xs={12} lg={6.1}>
      <Typography variant="h6">Choose Assignees</Typography>
      </Grid>
      <Grid item xs={12} lg={6.1}>
      <CustomTextField
        placeholder="Search"
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon icon="tabler:search" />
            </InputAdornment>
          ),
        }}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
      </Grid>
      <Grid item xs={12} lg={6.1}>
      <Box
        sx={{
          boxShadow: `0px 0px 8px rgb(0, 0, 0, 0.1)`,
          pb: 1,
        }}
      >
        <List sx={{ p: 0, maxHeight: '300px', overflowY: 'auto' }}>
          {filteredEmployees && filteredEmployees.map((employee, index) => (
            <ListItem key={employee.employeeID} disablePadding>
              <ListItemButton 
                // onClick={() => handleEmployeeCheck(employee, requestID, index)}
                >
                <ListItemAvatar>
                  <Avatar
                    src="/images/avatars/2.png"
                    alt={`${employee.firstName} ${employee.lastName}`}
                    sx={{ height: 32, width: 32 }}
                  />
                </ListItemAvatar>
                <ListItemText 
                  primary={`${employee.firstName} ${employee.lastName}`} 
                  // secondary={`Employee ID: ${employee.employeeID}`} 
                />
                <ListItemSecondaryAction>                  
                  <Checkbox
                    edge="end"
                    color="success"
                    tabIndex={-1}
                    disableRipple
                    onChange={() => handleEmployeeCheck(employee, requestID, index)}
                    checked={assignedUserIds.includes(employee.employeeID)}
                    disabled={!rules.canEdit}
                  />
                </ListItemSecondaryAction>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
          {rules.canEdit && (
            <Typography
              onClick={handleClear}
              sx={{
                px: 6,
                py: 2,
                color: "main.main",
                "&:hover": {
                  textDecoration: "underline",
                  cursor: "pointer",
                },
              }}
            >
              Clear
            </Typography>
          )}
      </Box>
      </Grid>
    </>
  )
}

export default AssignToComponent;


